import request from '@/utils/request';

export async function queryCurrent(params: { siteId: number; userId: number }) {
  return request('/admin/player-full-profile', { params });
}

export async function queryFakeList(params: { count: number }) {
  return request('/api/fake_list', {
    params,
  });
}

export async function getWalletDetail(params: { userId: number }) {
  return request('/admin/player-wallet', { params });
}

export async function updateWallet(params: { userId: number }, data: any) {
  return request('/admin/player-wallet', {
    method: 'POST',
    params: params,
    data: {
      ...data,
    },
  });
}

export async function banPlayer(params: { userId: number }, data: any) {
  return request('/admin/player-ban', {
    method: 'POST',
    params: params,
    data: {
      ...data,
    },
  });
}

export async function verifyKyc(params: { userId: number }, data: any) {
  return request('/admin/backend-kyc', {
    method: 'POST',
    params: params,
    data: {
      ...data,
    },
  });
}
export async function permaBanPlayer(params: { userId: number }, data: any) {
  return request('/admin/perma-ban', {
    method: 'POST',
    params: params,
    data: {
      ...data,
    },
  });
}
export async function convertLockedBonus(params: { userId: number }, data: any) {
  return request('/admin/convert-locked-bonus', {
    method: 'POST',
    params: params,
    data: {
      ...data,
    },
  });
}
export async function settleCreditNote(params: { userId: number }, data: any) {
  return request('/admin/service-requests/settle-credit-note', {
    method: 'POST',
    params: params,
    data: {
      ...data,
    },
  });
}
export async function adjustLockedBonus(params: { userId: number }, data: any) {
  return request('/admin/service-requests/adjust-locked-bonus', {
    method: 'POST',
    params: params,
    data: {
      ...data,
    },
  });
}
export async function listingAllFlags() {
  return request('/admin/list-flags');
}

export async function listingPlayerFlags(userId:number) {
  return request(`/admin/player-flags?userId=${userId}`,{ headers: {
    'Authorization': "beare",
} });
}

export async function unassignTags( data: any,userId:number) {
  return request(`/admin/player-flags/unassign?userId=${userId}`, {
    method: 'POST',
    data: {
      ...data,
    }, 
    headers: {
      'Authorization': "beare",
  },
  });
}

export async function assignTags( data: any,userId:number) {
  return request(`/admin/player-flags?userId=${userId}`, {
    method: 'POST',
    data: {
      ...data,
    }, 
    headers: {
      'Authorization': "beare",
  },
  });
}
export async function unfuzzPhone(userid:any) {
  return request(`/admin/player-phone-and-email?userId=${userid}`);
}

export async function updateWhatsappUrl(params:any) {
  return request(`/admin/ll/update-ll-contact-url`, {
    method: 'POST',
    data: {
      ...params,
    }, 
  });
}

export async function resetButton(userid:any) {
  return request(`/admin/reset-player-password?userId=${userid}`,
    {
      method: 'POST',
    }
  );
}

export async function resetRateLimit(data: {
  phone_number: string;
  reset: string;
  user_id: string;
}) {
  return request('/admin/reset-password-rate-limits', {
    method: 'POST',
    data,
  });
}

export async function getPlayerWithdrawalCriteria(userId: string | number) {
  return request(`/admin/player-withdrawal-criteria?userId=${userId}`);
}

export async function getPlayerEligiblePsps(userId: string | number) {
  return request(`/admin/player-eligible-psps?userId=${userId}`);
}

export async function getPlayerEligibleCoupons(userId: string | number) {
  return request(`/admin/player-eligible-coupons?userId=${userId}`);
}

export async function getConvertLockedToPlayBonusCoupons(userId: string | number) {
  return request(`/admin/convert-locked-to-play-bonus/coupons?user_id=${userId}`);
}

export async function convertLockedToPlayBonus(data: { user_id: number; code: string }) {
  return request('/admin/convert-locked-to-play-bonus', {
    method: 'POST',
    data,
  });
}
